module.exports = __webpack_public_path__ + "73a3d3e72f7378344b41c8ca49fef3f1.pdf";